export const PUBLIC_RUNTIME_ENV_KEYS = [
    'API_V',
    'CACHE_USER_SESSION',
    'GTM_API_KEY',
    'NEXT_PUBLIC_API_HOST',
    'NEXT_PUBLIC_CAPTCHA_KEY',
    'NEXT_PUBLIC_GF_CLICK_ENABLED',
    'NEXT_PUBLIC_GF_SECTION_ID',
    'NEXT_PUBLIC_GF_WRIMP_ENABLED',
    'NEXT_PUBLIC_LOGGER_TYPE',
    'NEXT_PUBLIC_MAPBOX_TOKEN',
    'NEXT_PUBLIC_MASTER_HOST',
    'NEXT_PUBLIC_ONLINE_CHAT_ID',
    'NEXT_PUBLIC_SENTRY_DSN',
    'NEXT_PUBLIC_SENTRY_ENABLED',
    'NEXT_PUBLIC_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE',
    'NEXT_PUBLIC_SENTRY_REPLAYS_SESSION_SAMPLE_RATE',
    'NEXT_PUBLIC_SENTRY_SAMPLE_RATE',
    'NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE',
    'NEXT_PUBLIC_STATIC_HOST',
    'NEXT_PUBLIC_STORYBOOK',
    'NEXT_PUBLIC_WINTER_DESIGN',
    'NEXT_PUBLIC_YM_COUNTER_NUMBER',
] as const;

export type TPublicRuntimeEnvKey = (typeof PUBLIC_RUNTIME_ENV_KEYS)[number];
export type TPublicRuntimeConfig = Partial<Record<TPublicRuntimeEnvKey, string>>;

type TRuntimeConfigWindow = Window & Partial<Record<'__SIMPLE_RUNTIME_CONFIG__', Readonly<TPublicRuntimeConfig>>>;

const publicRuntimeKeySet = new Set<string>(PUBLIC_RUNTIME_ENV_KEYS);

const buildTimeCompatibilityConfig: TPublicRuntimeConfig = {
    API_V: process.env.API_V,
    CACHE_USER_SESSION: process.env.CACHE_USER_SESSION,
    GTM_API_KEY: process.env.GTM_API_KEY,
    NEXT_PUBLIC_API_HOST: process.env.NEXT_PUBLIC_API_HOST,
    NEXT_PUBLIC_CAPTCHA_KEY: process.env.NEXT_PUBLIC_CAPTCHA_KEY,
    NEXT_PUBLIC_GF_CLICK_ENABLED: process.env.NEXT_PUBLIC_GF_CLICK_ENABLED,
    NEXT_PUBLIC_GF_SECTION_ID: process.env.NEXT_PUBLIC_GF_SECTION_ID,
    NEXT_PUBLIC_GF_WRIMP_ENABLED: process.env.NEXT_PUBLIC_GF_WRIMP_ENABLED,
    NEXT_PUBLIC_LOGGER_TYPE: process.env.NEXT_PUBLIC_LOGGER_TYPE,
    NEXT_PUBLIC_MAPBOX_TOKEN: process.env.NEXT_PUBLIC_MAPBOX_TOKEN,
    NEXT_PUBLIC_MASTER_HOST: process.env.NEXT_PUBLIC_MASTER_HOST,
    NEXT_PUBLIC_ONLINE_CHAT_ID: process.env.NEXT_PUBLIC_ONLINE_CHAT_ID,
    NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
    NEXT_PUBLIC_SENTRY_ENABLED: process.env.NEXT_PUBLIC_SENTRY_ENABLED,
    NEXT_PUBLIC_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE: process.env.NEXT_PUBLIC_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
    NEXT_PUBLIC_SENTRY_REPLAYS_SESSION_SAMPLE_RATE: process.env.NEXT_PUBLIC_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
    NEXT_PUBLIC_SENTRY_SAMPLE_RATE: process.env.NEXT_PUBLIC_SENTRY_SAMPLE_RATE,
    NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE: process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE,
    NEXT_PUBLIC_STATIC_HOST: process.env.NEXT_PUBLIC_STATIC_HOST,
    NEXT_PUBLIC_STORYBOOK: process.env.NEXT_PUBLIC_STORYBOOK,
    NEXT_PUBLIC_WINTER_DESIGN: process.env.NEXT_PUBLIC_WINTER_DESIGN,
    NEXT_PUBLIC_YM_COUNTER_NUMBER: process.env.NEXT_PUBLIC_YM_COUNTER_NUMBER,
};

export function readPublicRuntimeEnv(key: TPublicRuntimeEnvKey): string | undefined {
    if (!publicRuntimeKeySet.has(key)) {
        throw new Error(`${key} is not allowed in public runtime config`);
    }

    if ('undefined' === typeof window) {
        return process.env[key] ?? buildTimeCompatibilityConfig[key];
    }

    const runtimeWindow = window as TRuntimeConfigWindow;

    return runtimeWindow.__SIMPLE_RUNTIME_CONFIG__?.[key] ?? buildTimeCompatibilityConfig[key];
}
